import React, { FC } from "react";
import "./App.css";
import Form from './Form';

import { useAnchorWallet, useWallet } from '@solana/wallet-adapter-react';
import MessageView from "./MessageView";
import { clusterApiUrl, Connection, PublicKey } from "@solana/web3.js";
import { Wallet } from "@solana/wallet-adapter-wallets";
import messageService from "./Messages";
import { Program } from "@project-serum/anchor";
import { getProgram } from "./utils";
import FlipMove from 'react-flip-move';

const App: FC = () => {
  const { publicKey } = useWallet();
  const wallet = useAnchorWallet();
  //@ts-ignore
  const connection = new Connection(clusterApiUrl('mainnet-beta'), 'confirmed');
  return (
    <div className="sd">

      {(wallet && publicKey) &&
     // @ts-ignore
        <MyApp publicKey={publicKey} publicKeys={[]} wallet={wallet} connection={connection}/>
       }
      

    </div>
  );
}

interface FollowsProps {
  followKeys: PublicKey[],
  lookup: Function,
}

interface FollowsState {
  followKeys: PublicKey[],
}



class Follows extends React.Component<FollowsProps, FollowsState> {
  constructor(props: FollowsProps) {
    super(props)
    this.state = { followKeys: props.followKeys }
  }

  render() {
    const followList = this.props.followKeys.map((follow) => {
        return (
            <li className="item" key={follow.toString()}>
              <span className="followCreator">
              <button className="lookupButton" onClick = {() => this.props.lookup(follow)}>  {follow.toString()} </button>
              <br />
              <a href={`https://explorer.solana.com/address/${follow.toString()}`} target="_blank" rel="noopener noreferrer"> explorer </a>
              <button className="copyButton" data-tip='custom show' data-for="doCopy" data-event='click'
                onClick={() =>  {
                  navigator.clipboard.writeText(follow.toString());
                }
                }
              >
                Copy
              </button>
              </span>
              </li>
        )
    })
    return (
        <div>
        <h1>My Follows</h1>
        <div className="followScroller">
        <ul id="followList" className="follow-group">
          <FlipMove>
          {followList}
          </FlipMove>
        </ul>
        {/* <button onClick = {() => this.props.lookup(new PublicKey("FwvQ5TgFoTUPASPwT544DKD6J6Nj4eVQRLWdDXAbp7TY"))  }/ > */}
        </div>
        </div>
    )
  }
}


interface MyAppProps {
  publicKeys: PublicKey[],
  wallet: Wallet,
  publicKey: PublicKey,
  connection: Connection,
  // lookupUser: Function,
}

interface MyAppState {
  publicKeys: PublicKey[],
  wallet: Wallet,
  connection: Connection,
  publicKey: PublicKey,
  user: string,
  follows: PublicKey[] | undefined,
  viewingUser: boolean,
  program: Program,
  global: boolean,
}




class MyApp extends React.Component<MyAppProps, MyAppState> {
  constructor(props: MyAppProps) {
    super(props);
    this.state = {
    publicKeys: props.publicKeys,
    wallet: props.wallet,
    connection: props.connection,
    publicKey: props.publicKey,
    user: "",
    follows: undefined,
    viewingUser: false,
    global: false,
    // @ts-ignore
    program: getProgram(props.wallet, props.connection),
    };
    this.viewSelf = this.viewSelf.bind(this);
    this.viewUser = this.viewUser.bind(this);
    this.viewHome = this.viewHome.bind(this);
    this.viewGlobal = this.viewGlobal.bind(this);
    this.handleUserChange = this.handleUserChange.bind(this);
    this.followUser = this.followUser.bind(this);
    this.unfollowUser = this.unfollowUser.bind(this);

    this.refreshFollows();
    this.lookupUser = this.lookupUser.bind(this)

}

 viewSelf(): void {
  this.setState({publicKeys: [this.state.publicKey], global: false, viewingUser: false});
}

viewHome(): void {
  this.setState({publicKeys: this.state.follows || [], global: false, viewingUser: false});
}

viewGlobal(): void {
  this.setState({global: true, viewingUser: false})
}


async refreshFollows(): Promise<void> {
  const follows = await messageService.getFollows(this.state.program, new PublicKey(this.state.publicKey));
  this.setState({follows: follows})
}

async viewUser(): Promise<void> {
  //  alert("uhm");
  try {
    this.setState({publicKeys: [new PublicKey(this.state.user)], global: false, viewingUser: true})
  }
  catch (error){
    console.error(error);
  }
}

async followUser(): Promise<void> {
  const userPublicKey = this.state.publicKeys[0];
  const followAccount = await messageService.getFollowsKeypair(this.state.publicKey, this.state.program.programId);
  if (this.state.follows){
    await messageService.followAccount(this.state.program.provider, this.state.program, followAccount.publicKey, userPublicKey);
  }
  else {
    await messageService.initializeFollowAccount(this.state.program.provider, this.state.program, followAccount, userPublicKey);
  }
  this.refreshFollows();
}

async unfollowUser(): Promise<void> {
  const userPublicKey = this.state.publicKeys[0];
  const followAccount = await messageService.getFollowsKeypair(this.state.publicKey, this.state.program.programId);
  if (this.state.follows){
    await messageService.unfollowAccount(this.state.program.provider, this.state.program, followAccount.publicKey, userPublicKey);
  }
  else {
    throw new Error("Unable to find followers");
  }
  this.refreshFollows();
}

handleUserChange(event: React.FormEvent<HTMLInputElement>) {
  this.setState({user: event.currentTarget.value});
}


async lookupUser(userKey: PublicKey): Promise<void> {
  this.setState({publicKeys: [new PublicKey(userKey)], global: false, viewingUser: true});

}


render() {
  return (
    <div>
                 <div className='leftApp'>
                {this.state.wallet && <Form />}
                {<Follows followKeys={this.state.follows ? this.state.follows : []} lookup={this.lookupUser}/>}
            </div>
            <div className="messageView">
              <nav className="menuNav">
            <button onClick={this.viewSelf}> view my posts </button>
            <button onClick={this.viewGlobal}> view all posts </button>
            <button onClick={this.viewHome}> view users I follow </button>

            <div>
            <input type="text" value={this.state.user} onChange={this.handleUserChange} placeholder="search public key" />
            <button onClick={this.viewUser}> view user </button> </div> </nav>
            {this.state.viewingUser ?
            <section> <br/> <div> User address: {this.state.publicKeys[0].toString()}
            {(!this.state.follows || this.state.follows.length === 0 ||
            !(this.state.follows.some(elem =>{
              return this.state.publicKeys[0].toString() === elem.toString();
            }))
            ) ?
            <button onClick={this.followUser}> Follow User </button> :
            <button onClick={this.unfollowUser}> Unfollow User </button> } 

            </div> </section>: "" }

     {/*
//  @ts-ignore */}
    <MessageView key={[this.state.publicKeys.toString(),this.state.global].join()} lookup={this.lookupUser} publicKeys={this.state.publicKeys} global={this.state.global} wallet={this.state.wallet} connection={this.state.connection} />
  </div>
  </div>
);
}
}



export default App;


